import { get, post, put, del } from '@/utils/request'

// 不需要token的接口
export const getSystemInit = () => get('/api/wanlshop.common/init', {}, { requireAuth: false });

export const getBrandList = (data) => post(`/api/wanlshop.product/brandList`, data, { requireAuth: false });

export const getBrandListGet = (data) => get(`/api/wanlshop.product/brandList`, data, { requireAuth: false });

export const getProductList = (data) => get(`/api/wanlshop.product/lists`, data, { requireAuth: false });

export const getHotProductList = (data) => get(`/api/wanlshop.product/hotlists`, data, { requireAuth: false });

export const passwordLogin = (data) => post('/api/wanlshop.user/login', data, { requireAuth: false })

export const mobileLogin = (data) => post('/api/wanlshop.user/mobilelogin', data, { requireAuth: false })

export const refreshToken = (refreshToken) => post('/api/wanlshop.user/refreshAccessToken', refreshToken, { requireAuth: false })

export const getNoticeCategoryList = () => get('/api/wanlshop.article/getCategoryList', {}, { requireAuth: false })

export const getNoticeList = (data) => post('/api/wanlshop.article/getNoticeList', data, { requireAuth: false })

export const getNoticeDetail = (data) => get('/api/wanlshop.article/details', data, { requireAuth: false })

export const getExpressList = (data) => get('/api/wanlshop.common/getExpressList', data, { requireAuth: false })

export const getAreaList = () => get('/api/wanlshop.common/areaChildren', {}, { requireAuth: false })

// 营业执照识别
export const getLicenseInfoFromImage = (data) => post('/api/wanlshop.user/getLicenseInfoFromImage', data)


// 注册并且认证
export const regAndAuth = (data) => post('/api/wanlshop.user/regAndAuth', data)

// 获取认证信息
export const getRegAuthInfo = () => get('/api/wanlshop.user/getRegAuthInfo')

// 获取广告
export const getAdByIdentifier = (data) => get('/api/wanlshop.common/getAdByIdentifier', data)

// 获取推荐类型
export const getRecommendCategory = () => get('/api/wanlshop.common/getRecommendCategory')

// 获取推荐品牌列表
export const getRecommendBrandList = () => get('/api/wanlshop.common/getRecommendBrand')


// 需要token的接口
export const getUserInfo = () => get('/api/user/info')
export const updateUserInfo = (data) => put('/api/user/info', data)
export const getUserOrderList = (data) => post('/api/wanlshop.order/getOrderList', data);

// 购物车列表
export const getCartSynchro = (data) => post('/api/wanlshop.cart/synchro', data);

// 购物车操作
export const setCartStorage = (data) => post('/api/wanlshop.cart/storage', data);

// 购物车核实
export const setCartVerify = (data) => post('/api/wanlshop.cart/submitVerify', data);

// 获取订单详情
export const getOrderGoodsList = (data) => post('/api/wanlshop/order/getOrderGoodsList', data);

// 提交订单
export const addOrder = (data) => post('/api/wanlshop.order/addOrder', data);

export const getEstimatedExpressFee = (data) => post('/api/wanlshop.user/getEstimatedExpressFee', data)

export const getBalance = (data) => post('/api/wanlshop/pay/getBalance', data);

export const verifyPayPassword = (data) => post('/api/wanlshop.user/verifyPayPassword', data);

export const payment = (data) => post('/api/wanlshop/pay/payment', data);

export const sendSms = (data) => post('/api/wanlshop.sms/send', data); // 获取验证码

// 获取用户地址列表
export const getUserAddressList = () => get('/api/wanlshop.address/getaddress');

// 添加编辑收货地址
export const saveUserAddress = (data) => post('/api/wanlshop.address/address', data);

// 删除收货地址
export const deleteUserAddress = (data) => post('/api/wanlshop.address/deladdress', data);

// 获取购物车余额和订单数量
export const getUserOrderMoneyInfo = () => post('/api/wanlshop.user/getUserOrderMoneyInfo');

// 判断是不是VIP
export const getUserIsVip = () => post('/api/wanlshop.user/getUserIsVip');

// 获取商品详情信息
export const getProductInfo = (data) => get('/api/wanlshop/product/goods', data, { requireAuth: true })

// 获取订单列表
export const getOrderList = (data) => get('/api/wanlshop/order/getOrderList', data, { requireAuth: true })

// 获取支付信息
export const getPay = (data) => post('/api/wanlshop/pay/getPay', data, { requireAuth: true })

// 取消订单
export const cancelOrder = (data) => post('/api/wanlshop/order/cancelOrder', data, { requireAuth: true })

// 获取专属客服
export const getUserService = () => post('/api/wanlshop.user/getWechatCompanyInfo')

// 申请成为供应商
export const shopRegAndAuth = (data) => post('/api/wanlshop.shop/regAndAuth', data, { requireAuth: true })

export const getJoinInfo = () => post('/api/wanlshop.shop/getJoinInfo')

// 设置默认地址
export const setDefaultAddress = (data) => post('/api/wanlshop.address/setDefaultAddress', data)

// 设置用户信息
export const setUserProfile = (data) => post('/api/wanlshop/user/profile', data)

// 同步用户信息
export const refresh = () => post('/api/wanlshop/user/refresh')

// 签到
export const dosign = (data) => post('/api/wanlshop/signin/dosign', data)

// 获取签到信息
export const getSignin = (data) => post('/api/wanlshop/signin/getSignin', data)

// 获取积分记录
export const getScoreLog = (data) => post('/api/wanlshop/user/scoreLog', data)

// 获取余额记录
export const getMoneyLog = (data) => post('/api/wanlshop/pay/moneyLog', data)

// 查询参数列表
export const searchSpecList = (data) => post('/api/wanlshop.user/searchSpec', data)

// 查询对公账号信息
export const getUserAccInfo = () => post('/api/wanlshop.user/getUserAccInfo')

// 【询期货】获取询期货专区商品列表
export const getAllInquiryGoodsList = (data) => get('/api/inquiry/getAllInquiryGoodsList', data)

// 【询期货】提交商品报价
export const quotation = (data) => post('/api/inquiry/quotation', data)

// 【询期货】获取我发布的询期货列表
export const getInquiryList = (data) => get('/api/inquiry/getInquiryList', data)

// 【询期货】获取我发布的询期货详情
export const getInquiryDetail = (data) => get('/api/inquiry/inquiryDetail', data)

// 【询期货】获取报价列表
export const getQuotesList = (data) => get('/api/inquiry/quotesList', data)

// 【询期货】为商品选择报价
export const selctedQuotation = (data) => post('/api/inquiry/selctedQuotation', data)

// 【询期货】获取报价商品列表
export const getInquiryOrderGoodsList = (data) => post('/api/inquiry/getOrderGoodsList', data)

// 【询期货】获取我的询期货订单列表
export const getInquiryOrderList = (data) => get('/api/inquiry/getOrderList', data)

// 【询期货】创建询价单
export const createInquiry = (data) => post('/api//inquiry/createInquiry', data)

// 【询期货】编辑询价单
export const editInquiry = (data) => post('/api//inquiry/editInquiry', data)

// 【询期货】获取我的询期货订单详情
export const getInquiryOrderInfo = (data) => get('/api/inquiry/getOrderInfo', data)

// 【询期货】获取我的报价记录
export const getInquiryUserQuotesList = (data) => get('/api/inquiry/getUserQuotesList', data)

// 【询期货】取消订单
export const cancelInquiryOrder = (data) => post('/api/inquiry/cancelOrder', data)

// 【询期货】提交订单
export const addiInquiryOrder = (data) => post('/api/inquiry/addOrder', data)

// 【物流订单】列表
export const getUserExpressList = (data) => post('/api/wanlshop/express/getUserExpressList', data)

// 【物流订单】详情
export const getExpressDetail = (data) => post('/api/wanlshop/express/getExpressDetail', data)

// 【物流订单】获取预估运费
export const getEstimatePrice = (data) => post('/api/wanlshop/express/getEstimatePrice', data)

// 【物流订单】创建物流订单
export const createExpressOrder = (data) => post('/api/wanlshop.express/createOrder', data)

// 【物流订单】取消物流订单
export const canceExpressOrder = (data) => post('/api/wanlshop.express/cancelOrder', data)

// 【物流订单】删除物流订单
export const delExpressOrder = (data) => post('/api/wanlshop.express/delOrder', data)


// 带loading的接口
export const uploadFile = (data) => post('/api/wanlshop.common/upload', data, {
  showLoading: true,
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})